import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Hero = makeShortcode("Hero");
const DiscoverBlock = makeShortcode("DiscoverBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Hero slots="heading, text" background="rgb(154, 23, 34)" mdxType="Hero" />
    <h1 {...{
      "id": "cja-api-support"
    }}>{`CJA API support`}</h1>
    <p>{`Learn where to ask questions, report bugs, make feature requests, and spark discussions.`}</p>
    <h2 {...{
      "id": "communities"
    }}>{`Communities`}</h2>
    <p>{`Adobe actively participates in several communities. You can use any of the following communities for their designated purpose.`}</p>
    <DiscoverBlock slots="image, heading, link, text" width="25%" mdxType="DiscoverBlock" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "512px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "100%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/cja-apis/docs/static/5899ae6e7c46d7bb61ca5ad2000bd51b/5530d/experience_cloud.webp 320w", "/cja-apis/docs/static/5899ae6e7c46d7bb61ca5ad2000bd51b/2bf0f/experience_cloud.webp 512w"],
            "sizes": "(max-width: 512px) 100vw, 512px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/cja-apis/docs/static/5899ae6e7c46d7bb61ca5ad2000bd51b/dd4a7/experience_cloud.png 320w", "/cja-apis/docs/static/5899ae6e7c46d7bb61ca5ad2000bd51b/06341/experience_cloud.png 512w"],
            "sizes": "(max-width: 512px) 100vw, 512px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/cja-apis/docs/static/5899ae6e7c46d7bb61ca5ad2000bd51b/06341/experience_cloud.png",
            "alt": "Adobe Experience Cloud",
            "title": "Adobe Experience Cloud",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "adobe-experience-league"
    }}>{`Adobe Experience League`}</h3>
    <p><a parentName="p" {...{
        "href": "https://experienceleaguecommunities.adobe.com/t5/adobe-analytics/ct-p/adobe-analytics-community"
      }}>{`CJA forum`}</a></p>
    <p>{`Ask/answer questions, participate in discussions, or submit ideas around the CJA APIs.`}</p>
    <DiscoverBlock slots="link, text" width="25%" mdxType="DiscoverBlock" />
    <p><a parentName="p" {...{
        "href": "https://experienceleaguecommunities.adobe.com/t5/adobe-i-o-console/ct-p/adobe-io-console"
      }}>{`Adobe Developer forum`}</a>{` `}</p>
    <p>{`Ask/answer questions or participate in discussions around the Adobe Developer console.`}</p>
    <DiscoverBlock slots="image, heading, link, text" width="25%" mdxType="DiscoverBlock" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "120px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "100%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/cja-apis/docs/static/ef7a02b69836dc8b6a732a54c4200dcb/31f24/github.webp 120w"],
            "sizes": "(max-width: 120px) 100vw, 120px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/cja-apis/docs/static/ef7a02b69836dc8b6a732a54c4200dcb/be895/github.png 120w"],
            "sizes": "(max-width: 120px) 100vw, 120px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/cja-apis/docs/static/ef7a02b69836dc8b6a732a54c4200dcb/be895/github.png",
            "alt": "GitHub",
            "title": "GitHub",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "github"
    }}>{`GitHub`}</h3>
    <p><a parentName="p" {...{
        "href": "https://github.com/AdobeDocs/cja-apis/blob/main/.github/CONTRIBUTING.md"
      }}>{`Contributing`}</a></p>
    <p>{`Learn how you can contribute to the CJA API documentation.`}</p>
    <DiscoverBlock slots="link, text" width="25%" mdxType="DiscoverBlock" />
    <p><a parentName="p" {...{
        "href": "https://github.com/AdobeDocs/cja-apis/issues"
      }}>{`Issues`}</a></p>
    <p>{`Submit an issue to the repo for Adobe to address.`}</p>
    <DiscoverBlock slots="link, text" width="25%" mdxType="DiscoverBlock" />
    <p><a parentName="p" {...{
        "href": "https://github.com/AdobeDocs/cja-apis/pulls"
      }}>{`Pull requests`}</a></p>
    <p>{`View open pull requests for the repository.`}</p>
    <DiscoverBlock slots="image, heading, link, text" width="25%" mdxType="DiscoverBlock" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "500px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "100%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/cja-apis/docs/static/a3bed5e229e6efc7ffcf9bba6a90d127/5530d/slack.webp 320w", "/cja-apis/docs/static/a3bed5e229e6efc7ffcf9bba6a90d127/601b1/slack.webp 500w"],
            "sizes": "(max-width: 500px) 100vw, 500px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/cja-apis/docs/static/a3bed5e229e6efc7ffcf9bba6a90d127/dd4a7/slack.png 320w", "/cja-apis/docs/static/a3bed5e229e6efc7ffcf9bba6a90d127/0eb09/slack.png 500w"],
            "sizes": "(max-width: 500px) 100vw, 500px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/cja-apis/docs/static/a3bed5e229e6efc7ffcf9bba6a90d127/0eb09/slack.png",
            "alt": "Slack",
            "title": "Slack",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "slack"
    }}>{`Slack`}</h3>
    <p><a parentName="p" {...{
        "href": "https://join.measure.chat"
      }}>{`Request an invite`}</a></p>
    <p>{`Submission form to request joining #Measure, an industry-wide slack channel for multiple analytics platforms.`}</p>
    <DiscoverBlock slots="link, text" width="25%" mdxType="DiscoverBlock" />
    <p><a parentName="p" {...{
        "href": "https://measure.slack.com/messages/adobe-cja"
      }}>{`Measure slack`}</a></p>
    <p>{`The #adobe-cja channel within Measure Slack.`}</p>
    <DiscoverBlock slots="image, heading, link, text" width="25%" mdxType="DiscoverBlock" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "512px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "100%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/cja-apis/docs/static/2da12b7265d4242924ab4071b5667b48/5530d/stack-overflow.webp 320w", "/cja-apis/docs/static/2da12b7265d4242924ab4071b5667b48/2bf0f/stack-overflow.webp 512w"],
            "sizes": "(max-width: 512px) 100vw, 512px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/cja-apis/docs/static/2da12b7265d4242924ab4071b5667b48/dd4a7/stack-overflow.png 320w", "/cja-apis/docs/static/2da12b7265d4242924ab4071b5667b48/06341/stack-overflow.png 512w"],
            "sizes": "(max-width: 512px) 100vw, 512px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/cja-apis/docs/static/2da12b7265d4242924ab4071b5667b48/06341/stack-overflow.png",
            "alt": "Stack Overflow",
            "title": "Stack Overflow",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>
    <h3 {...{
      "id": "stack-overflow"
    }}>{`Stack Overflow`}</h3>
    <p><a parentName="p" {...{
        "href": "https://stackoverflow.com/questions/tagged/adobe-analytics"
      }}>{`Tagged questions`}</a></p>
    <p>{`Ask/answer developer questions tagged `}<inlineCode parentName="p">{`[adobe-analytics]`}</inlineCode>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      